import type { ConditionOperator, ViewFilterModifier } from "@regrello/graphql-api";

/** A type that describes the ways in which a __number__ value can be filtered. */
export type RegrelloFilterDefinition_NumberValue = {
  type: "number";
  filter:
    | { operator: "EQUALS"; value: number; modifier?: ViewFilterModifier }
    | { operator: "LESS_THAN"; value: number; modifier?: ViewFilterModifier }
    | { operator: "GREATER_THAN"; value: number; modifier?: ViewFilterModifier };
};

export const regrelloFilterOperators_NumberValue: Record<
  RegrelloFilterDefinition_NumberValue["filter"]["operator"],
  true
> = {
  EQUALS: true,
  GREATER_THAN: true,
  LESS_THAN: true,
};

export function getRegrelloDefaultFilterDefinitionNumberValue(): RegrelloFilterDefinition_NumberValue {
  return {
    type: "number",
    filter: {
      operator: "EQUALS",
      value: 0,
    },
  };
}
export function getRegrelloFilterDefinitionNumberValue(
  operator: ConditionOperator,
  value: number,
): RegrelloFilterDefinition_NumberValue | undefined {
  switch (operator) {
    case "EQUALS":
    case "GREATER_THAN":
    case "LESS_THAN":
      return {
        type: "number",
        filter: {
          operator,
          value,
        },
      };
    default:
      console.warn("Unrecognized operator for number filter:", operator);
      return undefined;
  }
}
